<!-- studio-dashboard.component.html -->
<div class="studio-layout">
  <!-- LEFT COLUMN (Firebase-Studio style) -->
  <section class="left-rail">
    <header class="greeting">
      <h1>
        <span class="hello">Hello,</span>
        <span class="name">{{ username.value || '' }}</span>
      </h1>
      <p class="subtitle">Welcome back</p>
    </header>

    <!-- Prototype box -->
    <div class="panel prompt-card">
      <div class="panel-title">Prototype an app with AI</div>
      <div class="prompt-input" tabindex="0" role="button" aria-label="Open AI prototype">
        <div class="prompt-icon" aria-hidden="true">✎</div>
        <div class="prompt-placeholder">An app that creates recipes from photos</div>
        <span class="tag">TAB</span>
        <button mat-stroked-button class="ghost-btn" type="button">
          More sample prompts
        </button>
      </div>
    </div>

    <!-- Quick start row -->
    <div class="panel quickstart-card">
      <div class="panel-title">Start coding an app</div>
      <div class="quick-actions">
        <button mat-stroked-button class="qa-btn">
          <mat-icon>add</mat-icon> New Workspace
        </button>
        <button mat-stroked-button class="qa-btn">
          <mat-icon>cloud_download</mat-icon> Import Repo
        </button>

        <div class="tech-icons" aria-label="Popular stacks">
          <span class="tech">go</span>
          <span class="tech">js</span>
          <span class="tech">java</span>
          <span class="tech">.net</span>
          <span class="tech">flutter</span>
          <span class="tech">react</span>
          <span class="tech">next</span>
        </div>
      </div>
    </div>

    <div class="brand panel quickstart-card">
      <div class="brand__logo">
        <div class="badge" aria-hidden="true">CRM</div>
        <div class="brand__text">
          <h1>VoyJaleas CRM</h1>
          <p>Gestión elegante para leads, clientes y tareas.</p>
        </div>
      </div>

      <div class="chips">
        <span class="chip">Website</span>
        <span class="chip">Web App</span>
        <span class="chip">Cotizacion</span>
      </div>

      <div class="orbs" aria-hidden="true">
        <span class="orb o1"></span>
        <span class="orb o2"></span>
        <span class="orb o3"></span>
      </div>
    </div>

    <footer class="studio-footer">
      <span class="dot"></span> Status
      <span class="sep">•</span> Discussion Forum
      <span class="sep">•</span> Docs
      <span class="sep">•</span> Feature Requests
    </footer>
  </section>

  <!-- LOGIN CARD -->
  <section class="right-rail">
    <header class="greeting"></header>

    <div class="auth-shell">

      <mat-card class="card">
        <mat-card-header class="card__header">
          <mat-card-title>Inicia sesión</mat-card-title>
          <mat-card-subtitle>Usa tu correo corporativo para entrar</mat-card-subtitle>
        </mat-card-header>

        <mat-card-content>
          <form [formGroup]="signin" (ngSubmit)="submit()" class="form">
            <mat-form-field appearance="fill">
              <mat-label>Correo</mat-label>
              <input matInput type="text" placeholder="tú@empresa.com" formControlName="username" autocomplete="username" />
              <mat-error *ngIf="username?.hasError('required')">El correo es obligatorio.</mat-error>
            </mat-form-field>

            <mat-form-field appearance="fill">
              <mat-label>Contraseña</mat-label>
              <input matInput [type]="hide ? 'password' : 'text'" formControlName="password" autocomplete="current-password" />
              <button
                type="button"
                mat-icon-button
                matSuffix
                (click)="hide = !hide"
                [attr.aria-label]="hide ? 'Mostrar contraseña' : 'Ocultar contraseña'"
                [attr.aria-pressed]="!hide">
                <mat-icon>{{ hide ? 'visibility' : 'visibility_off' }}</mat-icon>
              </button>
              <mat-error *ngIf="password?.hasError('required')">La contraseña es obligatoria.</mat-error>
              <mat-error *ngIf="password?.hasError('minlength')">Mínimo 6 caracteres.</mat-error>
            </mat-form-field>

            <div class="row">
              <mat-checkbox formControlName="remember">Recordarme</mat-checkbox>
              <a mat-button color="primary" class="link" routerLink="/forgot-password">¿Olvidaste la contraseña?</a>
            </div>

            <button mat-raised-button color="primary" class="submit" [disabled]="signin.invalid || loading" (click)="login()">
              <mat-icon>login</mat-icon>
              <span *ngIf="!loading">Entrar</span>
              <span *ngIf="loading">Entrando…</span>
            </button>

            <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

            <div class="divider">
              <span></span><em>o</em><span></span>
            </div>

            <div class="providers">
              <button mat-stroked-button type="button" class="provider">
                <img alt="" src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" />
                <span>Continuar con Google</span>
              </button>

              <button mat-stroked-button type="button" class="provider">
                <img alt="" src="https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg" />
                <span>Continuar con Microsoft</span>
              </button>
            </div>
          </form>
        </mat-card-content>

        <mat-card-footer class="foot">
          <small>Al continuar aceptas nuestros <a routerLink="/legal/terminos">Términos</a> y <a routerLink="/legal/privacidad">Privacidad</a>.</small>
        </mat-card-footer>
      </mat-card>

      <footer class="copy">© VoyJaleas</footer>
    </div>

  </section>
</div>
